import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/pcp-visits")({
  beforeLoad: ({ context }) => guardRoute(context.me, "pcp-visits"),
  component: Outlet,
});
